import React, {useState,useEffect} from 'react'
import {
    useParams,
    Navigate,
    Link
} from 'react-router-dom';
import Loader from '../../../components/Loader';
import axiosInstance from '../../../utils/api';
import { errorToast, successToast, warnToast } from '../../../utils/notification';
import { isValidDateFormat } from '../../../utils/helpers';

type Props = {}

const defaultData = {
    serial: "",
    customer: "",
    date_installation: "",
    simcard_activation: "",
    condition: "",
    simcard: "",
    remark: "",
    warranty: "",
    app_board: [],
    payment_status: "PENDING"
}

const InstallationAddEditV2 = (props: Props) => {
    const {type, id} = useParams()
    const [loading, setLoading] = useState(false)
    const [input, setInput] = useState<any>(defaultData)

    const [simcardInputShow, setSimcardInputShow] = useState(false)
    
    const [customerList, setCustomerList] = useState<Array<any>>([])
    const [productList, setProductList] = useState<Array<any>>([])
    const [serialList, setSerialList] = useState<Array<any>>([])
    const [fullSerialList, setFullSerialList] = useState<Array<any>>([])
    const [conditionList, setConditionList] = useState<Array<any>>([])
    const [connectivityList, setConnectivityList] = useState<Array<any>>([])
    const [pcbList, setPcbList] = useState<Array<any>>([])

    useEffect(() => {
        getList()
    }, [])
   
    // get Data on updated installation only when productList is filled
    useEffect(() => {
        if (type=="edit" && id && productList.length > 0) {
            getData(id)
        }
    }, [productList])
    
    if (type!="add"&&type!="edit") {
        console.log(1, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="add"&& id) {
        console.log(2, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="edit"&& !id) {
        console.log(3, type)
        return <Navigate to="/" replace={true} />
    }

    function getList() {
        setLoading(true)
        axiosInstance.get(`https://api.cloudatik.com/internal/operations/v2.0/page/installation/`).then(res => {
            console.log("res 2", res)
            setCustomerList(res.data.customer)
            setProductList(res.data.product)
            setSerialList(res.data.node)
            setFullSerialList(res.data.node)
            setConditionList(res.data.condition)
            setConnectivityList(res.data.connectivity)
            setPcbList(res.data.app_board)
           
        }).catch( err => {
            console.log("[ERR]", err)
        }).finally(() => {
            setLoading(false)
        })
    }


    function getData(installationId:string):void {
        setLoading(true)
        axiosInstance.get(`https://api.cloudatik.com/internal/operations/v2.0/installation/${installationId}`).then(res => {
            console.log("res getData", res.data)

            const matchingProduct = productList.find(product => product.id == Number(res.data.product.id))
            // console.log("matchingProduct", matchingProduct, productList)
            if (matchingProduct) {
                console.log("Matching Prefix:", matchingProduct.prefix)
                setInput({
                    ...res.data,
                    product: {
                        ...res.data.product,
                        prefix: matchingProduct.prefix,
                    },
                })
                
                // Reset serial if product prefix and serial prefix is not the same
                // Get the prefix from the selected product
                const selectedPrefix = matchingProduct.prefix
                
                if (res.data.serial && !res.data.serial.startsWith(selectedPrefix)) {
                    // reset input.serial
                    setInput((prev:any) => ({
                        ...prev,
                        "serial": ""
                    }))
                }
                
                // Filter serialList based on the prefix
                const filteredSerialList = fullSerialList.filter((serialItem: any) => 
                    serialItem.serial.startsWith(selectedPrefix) // Check if serial starts with the selected prefix
                )
                setSerialList(filteredSerialList)

            } else {
                setInput(res.data)
            }
        }).catch(err => {
            console.log(234, err)
            return <Navigate to="/" replace={true} />
        }).finally(() => {
            setLoading(false)
        })
    }

    function handleSubmit() {
        console.log("handleSubmit", input)
        if (type=="add") {
            if (input.product == null) {
                return warnToast("product is required")
            } else if (input.condition == "") {
                return warnToast("Condition is required")
            } else if (input.customer == "") {
                return warnToast("Customer is required")
            } else if (input.date_installation == "") {
                return warnToast("date_installation is required")
            } else if (!isValidDateFormat(input.date_installation)) {
                return warnToast("Date installation incorrect format")
            } else if (input.serial == "") {
                return warnToast("serial is required")
            } else if (!input.warranty || Number(input.warranty) <= 0 || Number(input.warranty) > 60) {
                return warnToast("Please enter a warranty between 1 and 60 months")
            }

            if (input.condition == "NEW" && input.product.prefix == "AM") {
                if (!input.connectivity || input.connectivity == "") {
                    return warnToast("Connectivity is required")
                } else if (!input.ec || input.ec == "") {
                    return warnToast("EC is required")
                } else if (!input.ph || input.ph == "") {
                    return warnToast("PH is required")
                } else if (!input.pumpa || input.pumpa == "") {
                    return warnToast("Pump A is required")
                } else if (!input.pumpa_speed || input.pumpa_speed == "") {
                    return warnToast("Pump A Speed is required")
                } else if (!input.pumpb || input.pumpb == "") {
                    return warnToast("Pump B is required")
                } else if (!input.pumpb_speed || input.pumpb_speed == "") {
                    return warnToast("Pump B Speed is required")
                } else if (!input.pumpc || input.pumpc == "") {
                    return warnToast("Pump C is required")
                } else if (!input.pumpc_speed || input.pumpc_speed == "") {
                    return warnToast("Pump C Speed is required")
                }
            } else if (input.condition == "NEW" && input.product.prefix == "AR") {
                if (!input.connectivity || input.connectivity == "") {
                    return warnToast("Connectivity is required")
                } else if (!input.radiation || input.radiation == "") {
                    return warnToast("radiation is required")
                }
            } else if (input.condition == "NEW") {
                if (!input.connectivity || input.connectivity == "") {
                    return warnToast("Connectivity is required")
                } else if (!input.sensors_serial || input.sensors_serial == "") {
                    return warnToast("Sensor serial is required")
                }
            }

            if (input.connectivity == "4G" || input.connectivity == "ROUTER") {
                if (input.simcard == "") {
                    return warnToast("simcard is required")
                } else if (input.simcard_activation == "") {
                    return warnToast("simcard_activation is required")
                } else if (!isValidDateFormat(input.simcard_activation)) {
                    return warnToast("Simcard installation date incorrect format")
                }
            }
            
    
            let payload : any = {}
            payload = {
                "customer": input.customer,
                "product": input.product,
                "serial": input.serial,
                "condition": input.condition,
                "date_installation": input.date_installation,
                "remark": input.remark,
                "warranty": input.warranty,
                "connectivity": input.connectivity,
                "app_board": input.app_board,
                "invoice": input.invoice,
                "payment_status": input.payment_status,
            }
            if (input.connectivity == "4G" || input.connectivity == "ROUTER") {
                payload["simcard_activation"] = input.simcard_activation
                payload["simcard"] = input.simcard
            } else {
                payload["simcard_activation"] = null
                payload["simcard"] = null

            }

            if (input.product.prefix == "AM") {
                payload["ec"] = input.ec
                payload["ph"] = input.ph
                payload["pumpa"] = input.pumpa
                payload["pumpa_speed"] = input.pumpa_speed
                payload["pumpb"] = input.pumpb
                payload["pumpb_speed"] = input.pumpb_speed
                payload["pumpc"] = input.pumpc
                payload["pumpc_speed"] = input.pumpc_speed

                // null if empty
                payload["sensors_serial"] = null
                payload["radiation"] = null
            } else if (input.product.prefix == "AR") {
                payload["radiation"] = input.radiation

                // null if empty
                payload["sensors_serial"] = null
                payload["ec"] = null
                payload["ph"] = null
                payload["pumpa"] = null
                payload["pumpa_speed"] = null
                payload["pumpb"] = null
                payload["pumpb_speed"] = null
                payload["pumpc"] = null
                payload["pumpc_speed"] = null
            } else if (input.product.prefix == "GH" || input.product.prefix == "HT" || input.product.prefix == "WS" || input.product.prefix == "HC") {
                payload["sensors_serial"] = input.sensors_serial
                
                // null if empty
                payload["ec"] = null
                payload["ph"] = null
                payload["pumpa"] = null
                payload["pumpa_speed"] = null
                payload["pumpb"] = null
                payload["pumpb_speed"] = null
                payload["pumpc"] = null
                payload["pumpc_speed"] = null
                payload["radiation"] = null
            }
            console.log("PAYLOAD CREATE", payload)
    
            setLoading(true)
            axiosInstance.post("https://api.cloudatik.com/internal/operations/v2.0/installation/", [payload]).then((res:any) =>{
                setLoading(false)
                successToast(res.data.message)
                setInput(defaultData)
            }).catch( err => {
                console.log(222, err)
                errorToast("Error adding installation")
            }).finally(() => {
                setLoading(false)
            })
        } else {
            if (input.product == null) {
                return warnToast("product is required")
            } else if (input.condition == "") {
                return warnToast("Condition is required")
            } else if (input.customer == "") {
                return warnToast("Customer is required")
            } else if (input.date_installation == "") {
                return warnToast("date_installation is required")
            } else if (!isValidDateFormat(input.date_installation)) {
                return warnToast("Date installation incorrect format")
            } else if (input.serial == "") {
                return warnToast("serial is required")
            } else if (!input.warranty || Number(input.warranty) <= 0 || Number(input.warranty) > 60) {
                return warnToast("Please enter a warranty between 1 and 60 months")
            }

            if (input.condition == "NEW" && input.product.prefix == "AM") {
                if (!input.connectivity || input.connectivity == "") {
                    return warnToast("Connectivity is required")
                } else if (!input.ec || input.ec == "") {
                    return warnToast("EC is required")
                } else if (!input.ph || input.ph == "") {
                    return warnToast("PH is required")
                } else if (!input.pumpa || input.pumpa == "") {
                    return warnToast("Pump A is required")
                } else if (!input.pumpa_speed || input.pumpa_speed == "") {
                    return warnToast("Pump A Speed is required")
                } else if (!input.pumpb || input.pumpb == "") {
                    return warnToast("Pump B is required")
                } else if (!input.pumpb_speed || input.pumpb_speed == "") {
                    return warnToast("Pump B Speed is required")
                } else if (!input.pumpc || input.pumpc == "") {
                    return warnToast("Pump C is required")
                } else if (!input.pumpc_speed || input.pumpc_speed == "") {
                    return warnToast("Pump C Speed is required")
                }
            } else if (input.condition == "NEW" && input.product.prefix == "AR") {
                if (!input.connectivity || input.connectivity == "") {
                    return warnToast("Connectivity is required")
                } else if (!input.radiation || input.radiation == "") {
                    return warnToast("radiation is required")
                }
            } else if (input.condition == "NEW") {
                if (!input.connectivity || input.connectivity == "") {
                    return warnToast("Connectivity is required")
                } else if (!input.sensors_serial || input.sensors_serial == "") {
                    return warnToast("Sensor serial is required")
                }
            }

            if (input.connectivity == "4G" || input.connectivity == "ROUTER") {
                if (input.simcard == "") {
                    return warnToast("simcard is required")
                } else if (input.simcard_activation == "") {
                    return warnToast("simcard_activation is required")
                } else if (!isValidDateFormat(input.simcard_activation)) {
                    return warnToast("Simcard installation date incorrect format")
                }
            }
            console.log("PAYLOAD UPDATE", input)
    
           
            setLoading(true)
            axiosInstance.put(`https://api.cloudatik.com/internal/operations/v2.0/installation/${id}/`, input)
            .then((res:any) =>{
                successToast(res.data.message)
                if (type=="edit" && id) {
                    getData(id)
                }
                setInput(defaultData)
            }).catch( err => {
                console.log(222, err)
                errorToast("Error updating installation")
            }).finally(() => {
                setLoading(false)
            })
        }
    }

        
    function handleChange(e:React.ChangeEvent<HTMLInputElement>|React.ChangeEvent<HTMLTextAreaElement>,field: string, index?:number ) {
        // console.log(e)
        if (field === "date_installation") {
            let value = e.target.value.replace(/[^\d]/g, "") // remove non-digits

            if (value.length >= 5 && value[4] !== "-") {
                value = value.slice(0, 4) + "-" + value.slice(4)
            }
            if (value.length >= 8 && value[7] !== "-") {
                value = value.slice(0, 7) + "-" + value.slice(7)
            }
          
            // Limit to 10 characters (YYYY-MM-DD)
            if (value.length > 10) value = value.slice(0, 10)
          
            setInput((prev: any) => ({
                ...prev,
                [field]: value,
            }))
        } else {
            setInput((prev:any) => ({
                ...prev,
                [field]: e.target.value
            }))
        }
    }

    function handleChangeSelect(e:React.ChangeEvent<HTMLSelectElement>, field:string) {
        // console.log("handleChangeSelect", e.target.selectedOptions[0].value)
        if (field=="customer") {
            setInput((prev:any) => ({
                ...prev,
                [field]: { customerid : e.target.selectedOptions[0].value , name: e.target.selectedOptions[0].text}
            }))
        } else if (field=="product") {
            //reset input.serial
            setInput((prev:any) => ({
                ...prev,
                "serial": ""
            }))
            
            // Get the prefix from the selected product
            const selectedPrefix = e.target.selectedOptions[0].getAttribute("data-prefix")

            // Filter serialList based on the prefix
            const filteredSerialList = fullSerialList.filter((serialItem: any) => 
                serialItem.serial.startsWith(selectedPrefix) // Check if serial starts with the selected prefix
            )
            
            console.log("selectedPrefix", selectedPrefix)
            
            setInput((prev:any) => ({
                ...prev,
                [field]: { id : e.target.selectedOptions[0].value , name: e.target.selectedOptions[0].text, prefix: e.target.selectedOptions[0].getAttribute("data-prefix")}
            }))

            setSerialList(filteredSerialList)
        } else if (field=="app_board") {
            // { "id": "28", "app_board_serial": "40C663"}
            setInput((prev: any) => {
                const currentSelection = prev[field] || [];
                const app_board = { id: e.target.selectedOptions[0].getAttribute("data-id"), app_board_serial: e.target.selectedOptions[0].value, };
          
                // Check if the item already exists in the selection
                const exists = currentSelection.some( (item: any) => item.id === app_board.id );
          
                // Update the selection based on existence
                const newSelection = exists ? currentSelection.filter((item: any) => item.id !== app_board.id) : [...currentSelection, app_board]
          
                return {
                    ...prev,
                    [field]: newSelection,
                };
            })
        } else {
            setInput((prev:any) => ({
                ...prev,
                [field]: e.target.selectedOptions[0].value
            }))
        }
    }
    
    return (
        <div className="col-12">
            {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                <div style={{float: "right", margin: "1rem", marginLeft: 0, marginBottom: 0}}>
                    <Link  to={`/installationv2`} className="nav-link collapsed">
                        <button type="button" className="btn btn-outline-secondary">Back</button>
                    </Link>
                </div>
                <h5 className="card-title">{type=="add" ? "Create" : "Edit"} Installation</h5>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Product</label>
                        <div className="col-sm-10">
                            <select className="form-select" aria-label="select" value={input.product ? input.product.id : ""} onChange={(e)=>handleChangeSelect(e, "product")}>
                                <option value={0} key={0}>-- Please Select --</option>
                                {productList.map((c, index) => {
                                    return (
                                        <option value={c.id} key={index} data-prefix={c.prefix}>{c.name}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Customer</label>
                        <div className="col-sm-10">
                            <select className="form-select" aria-label="select" value={input.customer.customerid} onChange={(e)=>handleChangeSelect(e, "customer")}>
                                <option value={-1} key={-1}>-- Please Select --</option>
                                {customerList.map((c, index) => {
                                    return (
                                        <option value={c.customerid} key={c.customerid}>{c.name}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Serial</label>
                        <div className="col-sm-10">
                            <select className="form-select" aria-label="select" value={input.serial || ""} onChange={(e)=>handleChangeSelect(e, "serial")}>
                                <option value={0} key={0}>-- Please Select --</option>
                                {(input.product && input.product.id != "0") && serialList.map((c, index) => {
                                    return (
                                        <option value={c.serial} key={index}>{c.serial}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Condition</label>
                        <div className="col-sm-10">
                            <select className="form-select" aria-label="select" value={input.condition || ""} onChange={(e)=>handleChangeSelect(e, "condition")}>
                                <option value={0} key={0}>-- Please Select --</option>
                                {conditionList.map((c, index) => {
                                    return (
                                        <option value={c} key={index}>{c}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Date Installation (YYYY-MM-DD)</label>
                        <div className="col-sm-10">
                            <div className="col-sm-10 w-100">
                                <input type="text" value={input.date_installation} className="form-control" onChange={(e)=>handleChange(e, "date_installation")}/>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Remark</label>
                        <div className="col-sm-10">
                            <textarea className="form-control" value={input.remark || ""} onChange={(e)=>handleChange(e, "remark")}/>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Warranty (month)</label>
                        <div className="col-sm-10">
                            <div className="col-sm-10 w-100">
                            <input type="number" min="1" max="60" required className="form-control" value={input.warranty} onChange={(e) => { handleChange(e, "warranty") }} />
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Connectivity</label>
                        <div className="col-sm-10">
                            <select className="form-select" aria-label="select" value={input.connectivity || ""} onChange={(e)=>handleChangeSelect(e, "connectivity")}>
                                <option value={0} key={0}>-- Please Select --</option>
                                {connectivityList.map((c, index) => {
                                    return (
                                        <option value={c} key={index}>{c}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>


                    {(input.connectivity == "4G" || input.connectivity == "ROUTER") && (
                        <>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Simcard Serial</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="text" value={input.simcard} className="form-control" onChange={(e)=>handleChange(e, "simcard")}/>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Simcard Activation Date (YYYY-MM-DD)</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="text" value={input.simcard_activation} className="form-control" onChange={(e)=>handleChange(e, "simcard_activation")}/>
                                </div>
                            </div>
                        </div>
                        </>
                    )}

                    {(input.product && (input.product.prefix == "GH" || input.product.prefix == "HT" || input.product.prefix == "WS" || input.product.prefix == "HC")) && (
                        <>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Sensors Serial</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="text" value={input.sensors_serial} className="form-control" onChange={(e)=>handleChange(e, "sensors_serial")}/>
                                </div>
                            </div>
                        </div>
                        </>
                    )}
                    {(input.product && (input.product.prefix == "AR")) && (
                        <>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">RAD Sensor Serial</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="text" value={input.radiation} className="form-control" onChange={(e)=>handleChange(e, "radiation")}/>
                                </div>
                            </div>
                        </div>
                        </>
                    )}

                    {(input.product && (input.product.prefix == "AM")) && (
                        <>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">EC Sensor Serial</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="text" value={input.ec} className="form-control" onChange={(e)=>handleChange(e, "ec")}/>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">pH Sensor Serial</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="text" value={input.ph} className="form-control" onChange={(e)=>handleChange(e, "ph")}/>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Pump A Serial</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="text" value={input.pumpa} className="form-control" onChange={(e)=>handleChange(e, "pumpa")}/>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Pump A Speed (L/hr)</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="number" value={input.pumpa_speed} className="form-control" onChange={(e) => { const value = e.target.value; if (value === "" || Number(value) > 0) { handleChange(e, "pumpa_speed"); } }}/>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Pump B Serial</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="text" value={input.pumpb} className="form-control" onChange={(e)=>handleChange(e, "pumpb")}/>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Pump B Speed (L/hr)</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="number" value={input.pumpb_speed} className="form-control" onChange={(e) => { const value = e.target.value; if (value === "" || Number(value) > 0) { handleChange(e, "pumpb_speed"); } }}/>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Pump C Serial</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="text" value={input.pumpc} className="form-control" onChange={(e)=>handleChange(e, "pumpc")}/>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Pump C Speed (L/hr)</label>
                            <div className="col-sm-10">
                                <div className="col-sm-10 w-100">
                                    <input type="number" value={input.pumpc_speed} className="form-control" onChange={(e) => { const value = e.target.value; if (value === "" || Number(value) > 0) { handleChange(e, "pumpc_speed"); } }}/>
                                </div>
                            </div>
                        </div>
                        </>
                    )}

                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">PCB Serial</label>
                        <div className="col-sm-10">
                            <select className="form-select" multiple aria-label="multiple select example" value={(input.app_board || []).map((board: any) => board.app_board_serial)} onChange={(e) => handleChangeSelect(e, "app_board")} >
                            <option value={0} key={0} disabled> -- Please Select -- </option>
                            {pcbList.map((c, index) => {
                                return (
                                    <option value={c.app_board_serial} key={index} data-id={c.id}>
                                        {c.app_board_serial}
                                    </option>
                                )
                            })}
                            </select>
                        </div>
                    </div>
                        
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Invoice No</label>
                        <div className="col-sm-10">
                            <div className="col-sm-10 w-100">
                                <input type="text" value={input.invoice} className="form-control" onChange={(e)=>handleChange(e, "invoice")}/>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Payment Status</label>
                        <div className="col-sm-10">
                            <select className="form-select" aria-label="select" value={(input.payment_status || "PENDING")} onChange={(e) => handleChangeSelect(e, "payment_status")} >
                                <option value={"PENDING"} key={1}>PENDING</option>
                                <option value={"PAID"} key={2}>PAID</option>
                                <option value={"FOC"} key={3}>FOC</option>
                            </select>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Platform Fees</label>
                        <div className="col-sm-10">
                            <div className="col-sm-10 w-100">
                                <input type="text" value={input.fee} className="form-control" onChange={(e)=>handleChange(e, "fee")}/>
                            </div>
                        </div>
                    </div>
                   
                    
                    <div className="text-start">
                        <button disabled={loading} type="button" className="btn btn-outline-info" onClick={()=>handleSubmit()}>{loading ? (<i className="bi bi-arrow-repeat"></i>) : (type=="add" ? "Submit" : "Update")}</button>
                    </div>          

                </div>
            </div>

        </div>
    )
}

export default InstallationAddEditV2

function formatDateToYYYYMMDD(date: any) {
    date = new Date(date)
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed, so we add 1
    const day = date.getDate().toString().padStart(2, '0'); // Pads single digit days with a leading zero
  
    return `${year}-${month}-${day}`;
}
  

// {
//     "product": input.product,
//     "customer": input.customer,
//     "app_board": [
//         {
//             "id": "28",
//             "app_board_serial": "40C663",
//             "remark": "SOM TESTED ONLY"
//         },
//         {
//             "id": "29",
//             "app_board_serial": "600F64",
//             "remark": "SOM TESTED ONLY"
//         },
//         {
//             "id": "30",
//             "app_board_serial": "88BA63",
//             "remark": "SOM TESTED ONLY"
//         },
//         {
//             "id": "34",
//             "app_board_serial": "60B62A",
//             "remark": "from Eletrolance. using china LM1117"
//         }
//     ],
//     "date_installation": "2021-10-27",
//     "condition": "new",
//     "connectivity": "wifi",
//     "remark": null,
//     "warranty": "12",
//     "simcard_activation": null,
//     "simcard": null,
//     "radiation": null,
//     "ec": "LECP17",
//     "ph": "LPHT17",
//     "pumpa": "2147483647",
//     "pumpa_speed": "17",
//     "pumpb": "36E44708B",
//     "pumpb_speed": "17",
//     "pumpc": "36E44686B",
//     "pumpc_speed": "17",
//     "misc": null,
//     "invoice": null,
//     "payment_status": null,
//     "serial": "AM1010"
// }